import { render, staticRenderFns } from "./NoSectionFoundContainer.vue?vue&type=template&id=60fabdec"
import script from "./NoSectionFoundContainer.vue?vue&type=script&lang=js"
export * from "./NoSectionFoundContainer.vue?vue&type=script&lang=js"
import style0 from "./NoSectionFoundContainer.vue?vue&type=style&index=0&id=60fabdec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports